/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_24_HoursInputs */



/**
* | output |
* | --- |
* | "24 Hours" |
*
* @param {Past_24_HoursInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_24_hours = /** @type {((inputs?: Past_24_HoursInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_24_HoursInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("24 heures")
	if (locale === "de") return /** @type {LocalizedString} */ ("24 Stunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("24 ore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("24 часа")
	if (locale === "es") return /** @type {LocalizedString} */ ("24 horas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("24小时")
	if (locale === "ja") return /** @type {LocalizedString} */ ("24時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("24 घंटे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("24 horas")
	return /** @type {LocalizedString} */ ("24 Hours")
});